import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { values: Array, color: { type: String, default: "#2563eb" } }

  connect() {
    this.render()
  }

  render() {
    const vals = this.valuesValue
    if (!vals.length) return

    const w = this.element.clientWidth || 120
    const h = 38
    const pad = 2

    const max = Math.max(...vals)
    const min = Math.min(...vals)
    const range = max - min || 1

    const xs = vals.map((_, i) =>
      pad + (i / (vals.length - 1)) * (w - pad * 2)
    )
    const ys = vals.map(v =>
      h - pad - ((v - min) / range) * (h - pad * 2)
    )

    const line = xs.map((x, i) =>
      `${i === 0 ? "M" : "L"}${x},${ys[i]}`
    ).join(" ")

    const area = `${line} L${xs.at(-1)},${h} L${xs[0]},${h} Z`

    this.element.innerHTML = `
      <svg width="${w}" height="${h}" viewBox="0 0 ${w} ${h}" preserveAspectRatio="none" style="max-width: 100%; height: auto;">
        <path d="${area}" fill="${this.colorValue}" opacity="0.15"/>
        <path d="${line}" fill="none" stroke="${this.colorValue}" stroke-width="1.5"/>
      </svg>`
  }
}
